<template>
  <v-autocomplete v-model="selectedAllUsers"
                  :items="allUsers"
                  :placeholder="active && selectedAllUsers.length == 1 ? $t('PERSONAL_CALENDAR.PARTICIPANT') : $t('MULTIPROJECTS.PARTICIPANTS')"
                  item-text="username" item-value="id"
                  filled height="35" hide-details multiple menu-props="offsetY"
                  return-object
                  :class="{ 'autocomplete-active': active }"
                  class="working-views-filter-users"
                  @change="update">
    <template #prepend-item>
      <v-list-item @click.stop>
        <v-switch v-model="configUsers.unassigned" :label="$t('MULTIPROJECTS.INCLUDE_UNASSIGNED')" color="primary" hide-details class="mt-0" @change="update">
        </v-switch>
      </v-list-item>
      <filter-toggle :selected-ids="selectedCompanyUsers" :sublist-ids="companyUserIds"
                     @update="selectedCompanyUsers = $event; update()">
        {{ $t('MULTIPROJECTS.ALL_COMPANY_USERS') }} ({{ companyUserIds.length }})
      </filter-toggle>
      <filter-toggle :selected-ids="selectedVirtualParticipants" :sublist-ids="virtualParticipantIds"
                     @update="selectedVirtualParticipants = $event; update()">
        {{ $t('MULTIPROJECTS.ALL_VIRTUAL_PARTICIPANTS') }} ({{ virtualParticipantIds.length }})
      </filter-toggle>
      <v-divider></v-divider>
      <template v-if="companyGroups.length">
        <v-list-item @click="expandCompanyGroups = ! expandCompanyGroups">
          <v-list-item-action class="justify-center">
            <v-icon :color="expandCompanyGroups ? 'primary' : ''">
              {{ expandCompanyGroups ? 'fas fa-caret-down' : 'fas fa-caret-right' }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title :class="expandCompanyGroups ? 'primary--text' : ''">{{ $t('GLOBAL.GROUPS') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-if="expandCompanyGroups">
          <filter-toggle v-for="group in companyGroups" :key="group.id"
                         :selected-ids="selectedCompanyUsers" :sublist-ids="userIdsByGroupId[group.id]" indent
                         @update="selectedCompanyUsers = $event; update()">
            <span>{{ group.title }} ({{ group.users.length }})</span>
          </filter-toggle>
        </template>
        <v-divider></v-divider>
      </template>
    </template>
    <template #item="{ parent, item }">
      <v-list-item-avatar class="mr-3">
        <img v-if="item.avatar" :src="item.avatar">
        <v-icon v-else class="color-inherit">{{ item.icon || 'fas fa-user' }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          <v-autocomplete-highlighted-text :vnodes="parent.genFilteredText(item.username)"></v-autocomplete-highlighted-text>
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <template #selection="{ index }">
      <span v-if="active && index === 0" class="white--text small nobr">{{ selectedAllUsers.length }}&nbsp;</span>
    </template>
  </v-autocomplete>
</template>

<style lang="scss">
  .working-views-filter-users {
    border-radius: 3px;
    flex: 0 0 150px;

    input::placeholder {
      font-size: 85%;
    }
    &:not(.autocomplete-active) input::placeholder {
      color: rgba(0, 0, 0, 0.87) !important;
    }

    background-color: #f5f5f5; // v-menu btn bg-color
    &.autocomplete-active {
      background-color: #00b100 !important; // successgreen

      .v-input__icon .v-icon {
        color: white !important;
      }

      input, input::placeholder {
        color: white !important;
      }
    }

    &.theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
      background: unset;
    }

    &.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {
      min-height: 36px;
      align-items: center;
    }

    &.v-text-field--enclosed .v-input__append-inner {
      margin-top: 4px;
    }

    .v-input__icon .v-icon {
      font-size: 18px;
      color: unset;
    }

    &.v-text-field>.v-input__control>.v-input__slot:before {
      border-style: none;
    }
  }
</style>

<script>
  export default {
    props: {
      planning: { type: Object, required: true },
      configElementsUsers: { type: Object, default: () => ({}) },
      active: { type: Boolean, default: false },
    },
    data() {
      return {
        configUsers: {},
        expandCompanyGroups: false,
      };
    },
    computed: {
      selectedCompanyUsers: {
        get() {
          return this.configUsers.selectedCompanyUsers;
        },
        set(newVal) {
          this.configUsers.selectedCompanyUsers.splice(0, this.configUsers.selectedCompanyUsers.length, ...newVal);
        },
      },
      selectedVirtualParticipants: {
        get() {
          return this.configUsers.selectedVirtualParticipants;
        },
        set(newVal) {
          this.configUsers.selectedVirtualParticipants.splice(0, this.configUsers.selectedVirtualParticipants.length, ...newVal);
        },
      },
      selectedAllUsers: {
        get() {
          const selectedAllUsers = [];
          this.companyUsers.forEach((user) => {
            if (this.selectedCompanyUsers.indexOf(user.id) == -1) return;
            selectedAllUsers.push(user);
          });
          this.virtualParticipants.forEach((user) => {
            if (this.selectedVirtualParticipants.indexOf(user.username) == -1) return;
            selectedAllUsers.push(user);
          });
          return selectedAllUsers;
        },
        set(newVal) {
          const newValArray = newVal === "" ? this.selectedAllUsers : newVal;
          this.selectedCompanyUsers = [];
          this.selectedVirtualParticipants = [];
          newValArray.forEach((user) => {
            if (user.id) {
              this.selectedCompanyUsers.push(user.id);
            } else {
              this.selectedVirtualParticipants.push(user.username);
            }
          });
        },
      },
      allUsers() {
        return this.companyUsers.concat(this.virtualParticipants);
      },
      allUsersCount() {
        return this.allUsers.length;
      },
      projectUsers() {
        const companyUsers = {};
        const virtualParticipants = {};
        this.planning.elements.forEach((item) => {
          (item.getUsers() || []).forEach((user) => {
            if (user.id) {
              const username = this.$store.getters['users/getUsername'](user);
              companyUsers[user.id] = { ...user, username };
            } else {
              const username = user.username || user.email;
              if (username && ! virtualParticipants[username]) {
                virtualParticipants[username] = { username };
              }
            }
          });
        });
        return {
          companyUsers: Object.values(companyUsers).sort((a, b) => (a.username < b.username ? -1 : 1)),
          virtualParticipants: Object.values(virtualParticipants).sort((a, b) => (a.username < b.username ? -1 : 1)),
        };
      },
      companyUsers() {
        return this.projectUsers.companyUsers;
      },
      companyUserIds() {
        return this.companyUsers.map(item => item.id);
      },
      virtualParticipants() {
        return this.projectUsers.virtualParticipants;
      },
      virtualParticipantIds() {
        return this.virtualParticipants.map(item => item.username);
      },
      companyGroups() {
        const companyGroups = [];
        (this.$store.getters['users/groups/getCompanyGroups'] || []).forEach((group) => {
          const groupUsers = group.users.filter(user => this.companyUserIds.includes(user.id)); // keep only projectUsers
          if (groupUsers.length) companyGroups.push({ ...group, users: groupUsers });
        });
        return companyGroups;
      },
      userIdsByGroupId() {
        return this.companyGroups.reduce((acc, group) => {
          acc[group.id] = group.users.map(user => user.id);
          return acc;
        }, {});
      },
    },
    watch: {
      configElementsUsers: {
        handler() {
          this.configUsers = {
            selectedCompanyUsers: this.configElementsUsers.selectedCompanyUsers,
            selectedVirtualParticipants: this.configElementsUsers.selectedVirtualParticipants,
            unassigned: this.configElementsUsers.unassigned,
          };
          // Initialize the data of the users filter
          this.configUsers.selectedCompanyUsers = _.intersection(this.configUsers.selectedCompanyUsers, this.companyUserIds); // handle deleted
          this.configUsers.selectedVirtualParticipants = _.intersection(this.configUsers.selectedVirtualParticipants, this.virtualParticipantIds); // handle deleted
        },
        immediate: true,
      },
    },
    methods: {
      update() {
        this.$emit('update:config-elements-users', this.configUsers);
      },
    },
  };
</script>
